module.exports = __webpack_public_path__ + "img/icon-share-hover.8150940.svg";